<script setup lang="ts">
import { computed, watch } from 'vue';
import { IonSpinner } from '@ionic/vue';

import ChipButton from '@/shared/components/ChipButton.vue';
import useTagCollections from '@/shared/composables/useTagCollections';

const props = defineProps({
	userTags: {
		type: Array<number>,
		required: false,
		default: function () {
			return [];
		},
	},
	autoSaveDelay: { type: Number, required: false, default: 0 },
});

const emit = defineEmits(['update:tagsCount']);

const { error, isError, isLoading, saveTags, selectChildTag, selectParentTag, tagsList, userTags } = useTagCollections(props.userTags, props.autoSaveDelay);

watch(userTags, (val) => emit('update:tagsCount', val.length), { deep: true });

const standaloneTags = computed(() => tagsList.value?.filter((t) => !t.children?.length) ?? []);
const parentTags = computed(() => tagsList.value?.filter((t) => t.children?.length) ?? []);

const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

defineExpose({ saveTags });
</script>

<template>
	<div class="flex flex-col p-4">
		<div v-if="isLoading">
			<ion-spinner name="dots"></ion-spinner>
		</div>
		<h1 v-if="isError">{{ error }}</h1>

		<div class="flex flex-wrap gap-2 mb-4">
			<ChipButton :label="tag.name.replace(/^#/, '')" :selected="userTags.includes(tag.id)" v-for="tag of standaloneTags" :key="tag.id" @click="selectParentTag(null as any, tag)" />
		</div>

		<div v-for="tagParent of parentTags" :key="tagParent.id" class="mb-4">
			<span class="w-full block font-sourcesanspro-semibold text-md text-white/80 mb-2">
				{{ capitalize(tagParent.name.replace(/^#/, '')) }}
			</span>
			<div class="flex flex-wrap gap-2">
				<ChipButton :label="tag.name.replace(/^#/, '')" :selected="userTags.includes(tag.id)" v-for="tag of tagParent.children" :key="tag.id" @click="selectChildTag(tag, tagParent)" />
			</div>
		</div>
	</div>
</template>
